import Cookies from 'js-cookie';
import { StateStorage } from 'zustand/middleware';

const cookieStorage: StateStorage = {
  getItem: (name: string): string | null => {
    return Cookies.get(name) ?? null;
  },
  setItem: (name: string, value: string): void => {
    Cookies.set(name, value, { expires: 400, path: '/' });
  },
  removeItem: (name: string): void => {
    Cookies.remove(name);
  },
};

export default cookieStorage;
